// Per-school setting validation -- iteration 144
import { z } from "zod";
import { SCHOOL_SETTING_KEY_LIST, type SchoolSettingKey } from "../types/school-setting.js";

/** A setting key must be one of the known keys. */
export const schoolSettingKeySchema = z.enum(
  SCHOOL_SETTING_KEY_LIST as [SchoolSettingKey, ...SchoolSettingKey[]],
);

/** Body for PUT /schools/:id/settings/:key */
export const updateSchoolSettingSchema = z.object({
  value: z.string().max(500),
});

export type UpdateSchoolSettingInput = z.infer<typeof updateSchoolSettingSchema>;
